import styled from 'styled-components';

export const LeftContainer = styled.div`
    flex: 1;
    flex-direction: column;
    margin-right: 5px;
    align-items: center;

    & > h1 {
        text-transform: uppercase;
    }

    .leftInnerContainer {
        flex-direction: column;
        background-color: ${props => props.theme.white};
        justify-content: center;
        align-items: center;
        width: 100%;
        max-width: 500px;
        flex: 1;
    }

    @media (max-width: ${props => props.theme.medium}) {
        margin-right: 0;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
`;



// WEBPACK FOOTER //
// ./src/components/funnel/FunnelLeftContainerStyle.js